export default {
	// 元旦
	newYear: false,
	// 春节
	chineseNewYear: false,
	// 春季
	spring: false,
	// 元宵节
	lantern: false,
	// 女神节
	goddess: false,
	// 劳动节
	labourDay: false,
	// 端午节
	dragonBoat: false,
	// 建军节
	armyBuilding: false,
	// 中秋节
	midAutumn: false,
	// 国庆节
	national: false,
	// 圣诞节
	merryChristmas: false,
	// 临时皮肤
	releaseSkin: true
}



// WEBPACK FOOTER //
// ./src/configs/festival-config.js